import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";
import { InputNumber } from "primereact/inputnumber";

import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";

import {
  getBodegasAct,
  getEstantesAct,
  getPosicionesAct,
  guardarBandeja,
  editarBandeja,
} from "../../../../../API/Suministros/SuministrosRequest";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";


const BandejaCrudModal = ({
  listBandejas,
  bandeja,
  bandejaDialog,
  setBandejaDialog,
  getPos,
  modo,
}) => {

  const toastDialog = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [show, setShow] = useState(false);

  const [estados, setEstados] = useState([{}]);
  const [bodega, setBodegas] = useState([{}]);
  const [estante, setEstante] = useState([{}]);
  const [posicionList, setPosicionList] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const [habilitar, setHabilitar] = useState(true);

  const initialValues = {
    IdBandeja: -1,
    NombreBandeja: "",
    NumeroBandeja: "",
    IdEstado: bandeja ? bandeja?.IdEstado : 5,
    Lado: ""
  };

  const lados = [
    { Lado: 'Ninguno'},
    { Lado: 'Derecho'},
    { Lado: 'Izquierdo'},
  ]

  const lados2 = [
    { Lado: 'Ninguno'},
    { Lado: 'Arriba'},
    { Lado: 'Abajo'},
  ]

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    const estadosTempo = await getEstadosCategory("General");
    const bodegaActiva = await getBodegasAct();
    const estanteActiva = await getEstantesAct();
    const posicionActiva = await getPosicionesAct();

    setEstados(estadosTempo);
    setBodegas(bodegaActiva);
    setEstante(estanteActiva);
    setPosicionList(posicionActiva);

    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === bandeja?.IdEstado);

    setValues({
      ...bandeja,
      Estado: estadoInicial,
      Lado: bandeja?.Lado,
      Bodega: bodegaActiva.find((b) => bandeja?.IdBodega === b.IdBodega),
      Estante: estanteActiva.find((es) => bandeja?.IdEstante === es.IdEstante),
      Posicion: posicionActiva.find(
        (po) => bandeja?.IdPosicion === po.IdPosicion
      ),
    });
    setLoading(false);
  };

  const onHide = () => {
    setBandejaDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.NombreBandeja) {
      error.NombreBandeja = true;
      error.error = true;
    }
    if (!values.NumeroBandeja) {
      error.NumeroBandeja = true;
      error.error = true;
    }

    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }

    if (!values.Bodega || !values.Bodega.IdBodega) {
      error.IdBodega = true;
      error.error = true;
    }

    if (!values.Estante || !values.Estante.IdEstante) {
      error.IdEstante = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const bandejaExistsWithSameName = () => {
    const sameNameBandejas = listBandejas.filter(
      (item) =>
        item.NombreBandeja?.toLowerCase().trim() ===
          values.NombreBandeja?.toLowerCase().trim() &&
        Number(item.IdBodega) === Number(values.Bodega?.IdBodega) &&
        Number(item.IdEstante) === Number(values.Estante?.IdEstante) &&
        Number(item.IdPosicion) === Number(values.Posicion?.IdPosicion) &&
        (item.Lado || "Ninguno") === (values.Lado?.Lado || "Ninguno") &&
        Number(item.IdBandeja) !== Number(values.IdBandeja)
    );

    return sameNameBandejas.length > 0;
  };

  const bandejaExistsWithSameNumber = () => {
    const sameNumberBandejas = listBandejas.filter(
      (item) =>
        Number(item.NumeroBandeja) === Number(values.NumeroBandeja) &&
        Number(item.IdBodega) === Number(values.Bodega?.IdBodega) &&
        Number(item.IdEstante) === Number(values.Estante?.IdEstante) &&
        Number(item.IdPosicion) === Number(values.Posicion?.IdPosicion) &&
        (item.Lado || "Ninguno") === (values.Lado?.Lado || "Ninguno") &&
        Number(item.IdBandeja) !== Number(values.IdBandeja)
    );

    return sameNumberBandejas.length > 0;
  };

  const agregarBandeja = async () => {
    const e = verificarInfo();
    if (!e.error) {
      if (bandejaExistsWithSameName()) {
        toastShow(toastDialog, "error", "Error", "Ya existe una Bandeja con el mismo nombre en este Estante.");
        return;
      }
      if (bandejaExistsWithSameNumber()) {
              toastShow(
                toastDialog,
                "error",
                "Error",
                "Ya existe una fila con el mismo numero en esta bodega y estante."
              );
              return;
      }

      let estadoId = null;
      if (values.Estado) {
        estadoId = values.Estado.IdStatus;
      }

      const a = {
        IdBandeja: values?.IdBandeja,
        NombreBandeja: values.NombreBandeja,
        NumeroBandeja: values.NumeroBandeja,
        IdPosicion: values.Posicion.IdPosicion,
        IdEstado: estadoId,
        IdUserCreate: userAuth?.IdUser,
        Lado: values?.Lado?.Lado === "Ninguno" ? null : values?.Lado?.Lado
      };

      if (a.IdBandeja > 0) {
        setLoading(true);
        const resultado = await editarBandeja(a);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toastDialog, "success", "Datos Editados", resultado[0]?.MENSAJE);
          getPos();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toastDialog, "error", "Error", resultado[0]?.MENSAJE);
        }
      } else {
        const resultado = await guardarBandeja(a);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(toastDialog, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getPos();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toastDialog, "error", "Error", resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarBandeja();
          } else {
            agregarBandeja();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (bandejaDialog) {
      getValoresIniciales();
    }
  }, [bandejaDialog]);

  const dialogTitle = modo === "Crear" ? "Nueva Posición" : "Modificar Posición";

  return (
    <div>
      <Dialog
        visible={bandejaDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        appendTo="self"
        style={{ width: "55vw" }}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h2 className="me-3">{dialogTitle}</h2>
            </div>
            <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor">
              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputText
                    name="NombreBandeja"
                    value={values.NombreBandeja}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.NombreBandeja ? "p-invalid" : ""}
                  />
                  <label htmlFor="NombreBandeja">Nombre de la Posición</label>
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputNumber
                    name="NumeroBandeja"
                    value={values.NumeroBandeja}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    useGrouping={false}
                    className={error.NumeroBandeja ? "p-invalid" : ""}
                  />
                  <label htmlFor="NumeroBandeja">Numero de Posición</label>
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Estado"}
                    value={values.Estado}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
               {/* AutoCompleteDropdown De Bodega */}
              <div className="field col-4 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Bodega"}
                    value={values.Bodega}
                    items={bodega}
                    field={"NombreBodega"}
                    label={"Bodega"}
                    handleInputChange={(e) => {
                      handleInputChange(e);
                      setValues((prevValues) => ({
                        ...prevValues,
                        Estante: null,
                        Posicion: null,
                        Lado: null,
                      }));
                    }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdBodega ? "p-invalid" : ""}
                  />
                </span>
              </div>

              {/* AutoCompleteDropdown De Estante */}
              <div className="field col-4 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    enable={!!values.Bodega && habilitar}
                    name={"Estante"}
                    value={values.Estante}
                    items={estante}
                    field={"NombreEstante"}
                    label={"Estante"}
                    handleInputChange={(e) => {
                      handleInputChange(e);

                      setValues((prevValues) => ({
                        ...prevValues,
                        Posicion: null,
                        Lado: null,
                      }));
                    }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdEstante ? "p-invalid" : ""}
                    filterValue={values?.Bodega}
                    itemsFilter={(e) => {
                      let filtro = estante.filter(
                        (s) => s.IdBodega === values?.Bodega?.IdBodega
                      );
                      let filtro2 = values?.Bodega?.IdBodega;

                      if (filtro?.length === 0 && filtro2) {
                        toastShow(
                          toastDialog,
                          "warn",
                          "Seleccione otra Bodega",
                          "La Bodega seleccionada no cuenta con estantes disponibles"
                        );
                      }
                      return filtro;
                    }}
                  />
                </span>
              </div>

               {/* AutoCompleteDropdown De las Filas */}
              <div className="field col-4 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    enable={!!values.Estante && habilitar}
                    name={"Posicion"}
                    value={values.Posicion}
                    items={posicionList}
                    field={"NombrePosicion"}
                    label={"Fila"}
                    handleInputChange={(e) => {
                      handleInputChange(e);

                      setValues((prevValues) => ({
                        ...prevValues,
                        Lado: null,
                      }));
                    }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdEstante ? "p-invalid" : ""}
                    filterValue={values?.Estante}
                    itemsFilter={(e) => {
                      let filtro = posicionList.filter(
                        (s) => s.IdEstante === values?.Estante?.IdEstante
                      );
                      let filtro2 = values?.Estante?.IdEstante;

                      if (filtro?.length === 0 && filtro2) {
                        toastShow(
                          toastDialog,
                          "warn",
                          "Seleccione otro Estante",
                          "El Estante seleccionado no cuenta con Posiciones disponibles"
                        );
                      }
                      return filtro;
                    }}
                  />
                </span>
              </div>
            </div>


            <div className="modal__input-contenedor">
              {values?.Bodega?.IdBodega !== 6 && 
                <div className="field col-4 me-2 mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Lado"}
                      value={values.Lado}
                      items={lados}
                      field={"Lado"}
                      label={"Lado"}
                      handleInputChange={(e) => { handleInputChange(e)}}
                    />
                  </span>
                </div>
              }

              {values?.Bodega?.IdBodega === 6 &&
                <div className="field col-4 me-2 mt-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Lado"}
                      value={values.Lado}
                      items={lados2}
                      field={"Lado"}
                      label={"Lado"}
                      handleInputChange={(e) => { handleInputChange(e)}}
                    />
                  </span>
                </div>
              }
            </div>

          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default BandejaCrudModal;
